import { Link } from 'react-router-dom';
import UserMenu from './UserMenu';

const Header = () => (
  <header className="sticky top-0 z-20 h-12 border-b border-neutral-200 bg-white">
    <div className="flex h-full items-center justify-between px-4 sm:px-6 lg:px-8">
      <Link to="/" className="flex items-center no-underline">
        <span className="whitespace-nowrap text-lg font-bold tracking-tight">
          <span className="text-brand-500">Duo</span>
          <span className="text-neutral-800"> Documentation</span>
        </span>
      </Link>
      <UserMenu />
    </div>
  </header>
);

export default Header;
